import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';

import {StockAction} from 'AppAction';
import Dispatcher from 'service/Dispatcher';

class StockStore extends ReduceStore {

    constructor() {
		super(Dispatcher);
    }
    

    getInitialState() {
        return Immutable.Map();
    }

    getStockOwners() {
        return this.getState().get(StockAction.LOAD_STOCK_OWNERS) || null;
    }


    getStockOwner(ownerName){
        return this.getState().get(StockAction.LOAD_SINGLE_STOCK_OWNER+"_"+ownerName) || null;
    }


    getStocks(ownerName) {
        return this.getState().get(StockAction.LOAD_OWNER_STOCKS+"_"+ownerName) || null;
    }

    getStockProductHistory(stockProductId) {
        return this.getState().get(StockAction.LOAD_STOCK_HISTORY+"_"+stockProductId) || null;
    }

    reduce(state, action) { 
        switch (action.type) {
            case StockAction.LOAD_STOCK_OWNERS:
                const stockOwners = action.stockOwners;

                for(var i in stockOwners) {
                    const owner = stockOwners[i];
                    state = state.set(StockAction.LOAD_SINGLE_STOCK_OWNER+"_"+owner.ownerAlias, owner);
                }

                return state.set(StockAction.LOAD_STOCK_OWNERS, stockOwners);
            case StockAction.LOAD_SINGLE_STOCK_OWNER:
                return state.set(StockAction.LOAD_SINGLE_STOCK_OWNER+"_"+action.stockOwner.ownerAlias, action.stockOwner);
            
            case StockAction.LOAD_OWNER_STOCKS:
                return state.set(StockAction.LOAD_OWNER_STOCKS+"_"+action.ownerAlias, action.stocks);
            case StockAction.CLEAR_OWNER_STOCKS:
                return state.set(StockAction.LOAD_OWNER_STOCKS+"_"+action.stockOwner, null);

            case StockAction.LOAD_STOCK_HISTORY:
                return state.set(StockAction.LOAD_STOCK_HISTORY+"_"+action.stockProductId, action.history);
            default:
				break;
        }
        return state;
    }
}

export default new StockStore();


// WEBPACK FOOTER //
// ./src/stores/StockStore.js